<div class="login-card">
  <div class="card-header">
    <div class="logo-mark">
      <img src="assets/FOX_main.png" alt="Fox Sports" class="logo-img" />
    </div>
    <p class="app-subtitle">Hệ thống quản lý</p>
  </div>

  <form class="login-form" (ngSubmit)="login()" #loginForm="ngForm">
    <div class="form-group">
      <label class="form-label">Số điện thoại</label>
      <div class="input-wrapper">
        <svg class="input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
        <input
          class="form-input"
          type="text"
          name="username"
          placeholder="Nhập số điện thoại"
          [(ngModel)]="username"
          autocomplete="username"
          required
        />
      </div>
    </div>

    <div class="form-group">
      <label class="form-label">Mật khẩu</label>
      <div class="input-wrapper">
        <svg class="input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
        <input
          class="form-input"
          [type]="showPassword ? 'text' : 'password'"
          name="password"
          placeholder="Nhập mật khẩu"
          [(ngModel)]="password"
          autocomplete="current-password"
          required
        />
        <button type="button" class="toggle-password" (click)="showPassword = !showPassword" tabindex="-1">
          <svg *ngIf="!showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
            <circle cx="12" cy="12" r="3"/>
          </svg>
          <svg *ngIf="showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
            <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
            <line x1="1" y1="1" x2="23" y2="23"/>
          </svg>
        </button>
      </div>
    </div>

    <button type="submit" class="login-btn" [disabled]="!username || !password">
      <span>Đăng nhập</span>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="5" y1="12" x2="19" y2="12"/>
        <polyline points="12 5 19 12 12 19"/>
      </svg>
    </button>
  </form>

  <p class="forgot-text">Nếu quên mật khẩu, vui lòng liên hệ quản trị viên.</p>
</div>
